var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","background":"#667aa6"}},[_c('div',{staticClass:"unlock-con"},[_c('unlock',{attrs:{"avatorPath":_vm.avatorPath},on:{"on-unlock":_vm.handleUnlock}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }